<template>
  <div class="bar">
    <div></div>
    <div></div>
    <div></div>
  </div>
</template>

<script>
export default {
  name: 'BottomColorBar',
}
</script>

<style scoped>
.bar {
  position: absolute;
  bottom: 0;
  left: 0;
  right: 0;

  height: 10px;
}

.bar div {
  position: absolute;
  bottom: 0;

  display: inline-block;
  height: 100%;
}

.bar div:nth-child(1) {
  left: 0;
  right: 66%;
  background-color: #E95542;
}

.bar div:nth-child(2) {
  left: 33%;
  right: 33%;
  background-color: #99CC33;
}

.bar div:nth-child(3) {
  left: 66%;
  right: 0;
  background-color: #1F8A92;
}
</style>



// WEBPACK FOOTER //
// src/components/buyer-listing-details-as-pdf/partials/BottomColorBar.vue